import { Control, Controller } from 'react-hook-form'

import {
  DateRangeFilterRow,
  DateRangeFilterRowIProps,
} from './DateRangeFilterRow'

type DateRangeFilterFieldIProps = Omit<
  DateRangeFilterRowIProps,
  'value' | 'onChange'
> & {
  control: Control<any>
  name: string
}

/**
 * `react-hook-form`-connected DateRangeFilterRow: owns the `Controller` so a
 * drawer body can declare the field in one line. Seeded/reset by the form's
 * `defaultValues` (see `./FilterDrawer`).
 */
export const DateRangeFilterField = ({
  control,
  name,
  ...rowProps
}: DateRangeFilterFieldIProps) => (
  <Controller
    control={control}
    name={name}
    render={({ onChange, value }) => (
      <DateRangeFilterRow {...rowProps} onChange={onChange} value={value} />
    )}
  />
)
